$(document).ready(function () {
  $(".expandable-menu .title-footer").on("click", function () {
    var $self = $(this),
      $menuLinks = $self.next();

    $self.toggleClass("expanded-footer");
    $menuLinks.slideToggle(300);
  });
});
